export function getFileExpirationFromTaskName(task_name) {
    const timestampStr = task_name?.split("_").pop();
    let month = ((30 * 24 * 60 * 60) * 1000) - (60*60*1000)
    const expiresTimestamp = (parseFloat(timestampStr) * 1000) + month;
    const currentTimestamp = Date.now()
    
    if(expiresTimestamp < currentTimestamp) return false;
    
    const expiresDate = new Date(expiresTimestamp);
    const formattedDate = expiresDate.toLocaleString('en-CA');
    return formattedDate;
}

export function getDownloadUrl(message) {
    const messageObj = JSON.parse(message)
    return messageObj?.url
}

export function getRequestTime(task_name) {
    const timestampStr = task_name?.split("_").pop();
    const timestamp = parseFloat(timestampStr);
    const date = new Date(timestamp * 1000);
    const formattedDate = date.toLocaleString('en-CA');
    return formattedDate
}

export function getDateRange(task_name) {
    const parts = task_name.split("_");
    const dates = parts.filter(part => /^\d{4}-\d{2}-\d{2}$/.test(part));
    const startDate = dates[0];
    const endDate = dates[1] || startDate;
    return `${startDate} ~ ${endDate}`;
}

export function mapLocaleToLanguage(locale) {
  const localeMap = {
    'en': 'English',
    'ja': 'Japanese',
  };

  return localeMap[locale] || 'English';
}